export default __webpack_public_path__ + "static/media/alert-error.782c80ab.svg";